<template>
  <div class="dropdown_new_no_play_label" @click.stop="">
    <div class="new_no_play_label">
      <div style="height: 330px;overflow: auto;">
        <div style="padding: 15px;">
          <!-- :isMuilt="item.selectType == '2'" -->
          <SpeGroup :list="labelList" v-model="result" isMuilt limit></SpeGroup>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button size="mini" @click="cancelTags">取消</el-button>
      <el-button class="save" @click="saveCondition" size="mini">保存</el-button>
    </div>
  </div>
</template>

<script>
import SpeGroup from '@/views/PutOrder/components/OrderForm/SpeGroup'
import searchLabelsMix from '@/utils/searchLabelsMix'
export default {
  name: "NewNoPlayLabel",
  mixins: [ searchLabelsMix ],
  components: { SpeGroup },
  props: ['value', 'all'],
  data () {
    return {
      result: [],
    }
  },
  computed: {
    labelList(){
     return this.all.map(item=>{
        return { name: item.dictItemName, labelValue: item.dictItemName}
      })
    }
  },
  created () {
    this.value.forEach(el => {
      this.all.map(item=>{
        if(item.dictItemName === el){
          this.result.push({ name: item.dictItemName, labelValue: item.dictItemName})
        }
      })
    })
  },
  watch: {
    result: {
      immediate: true,
      handler (v) {
      }
    },
  },
  methods: {
    cancelTags () {
      this.$emit('close')
    },

    saveCondition () {
      const dictItemCodes = this.result.map(item=>{
       return item.labelValue
      })

      this.$emit('input', dictItemCodes)
      console.log('wyt debug ditu input ' + dictItemCodes)
      this.cancelTags()
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown_new_no_play_label {
  width: 420px;
  position: absolute;
  left: 600px;
  top: 60px;
  background: #FFF;
  border-radius: 4px;
  box-shadow: 0 6px 12px 0 rgba(40, 39, 41, 0.2);
  padding-top: 20px;
  z-index: 2;
  .new_no_play_label {
    overflow: auto;
    text-align: center;
    > div {
      text-align: left;
      margin: 0 auto;
    }
    span {
      display: inline-block;
      position: relative;
      width: 87px;
      line-height: 30px;
      border: 1px solid #E9E9E9;
      margin: 5px;
      font-size: 12px;
      cursor: pointer;
      text-align: center;
      img {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
      }
      &.select {
        border-color: #282729;
        img {
          display: block;
        }
      }
    }
  }
  .footer {
    border-top: 1px solid #E9E9E9;
    padding: 10px;
    text-align: center;
    button {
      width: 80px;
      &.save {
        background: linear-gradient(315deg, #ff846d 0%, #ff3973 100%);
        color: #fff;
      }
    }
  }
}

</style>
